<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <slot slot="activator"></slot>
    <v-card>
      <v-card-title class="headline">Are you sure you want to delete it?</v-card-title>
      <v-card-actions>
        <v-btn color="error" @click="() => { yes(); dialog = false}">Yes</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="dialog = false">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'RemoveDialog',
    props: ['yes'],
    data() {
      return {
        dialog: false
      }
    }
  }
</script>
